//Common constants
export const CommonConstants = {
  DefaultLanguageCode: "en",
  DefaultLanguageName: "English",
  ArabicLanguageCode: "ar",
};

export const SignUpSteps = {
  GET_STARTED: "GetStarted",
  CONFIRM_MOBILE: "ConfirmMobile",
  AUTO_FILL_ID: "AutoFillID",
  BASIC_INFO: "BasicInfo",
  UPLOAD_KYC: "UploadKYC"
}

export const OwnerType = {
  FLEET_OWNER: "FleetOwner",
  INDIVIDUAL_OWNER: "IndividualOwner",
  STO: "STO",
  INTERNAL_SOURCE: 'InternalSourcer',
  BROKER: 'Broker',
 FLEET_OWNER_C:'FleetOwnerC'
  // STO and IndividualOwner both same
}

export const AccessFields = {
  ShipperName: "Shipper Name",
  MobileNumber: "Mobile number",
  AddressLine1: "Address Line 1",
  AddressLine2: "Address Line 2",
  AddressLine3: "Address Line 3",
  Email: "Email",
  StateProvince: "State OR Province",
  City: "City",
  Zipcode: "Zipcode",
  Logo: "Logo",
  AllowBanUnBan: "AllowBanUnBan",
  BusinessType: "Business type",
  Industry: "Industry",
  Category: "Category",
  Commodity: "Commodity",
  OperatingCountries: "Operating countries",
  AnnualRevenue: "Annual revenue",
  NumberOfShipmentPerYear: "Number of shipment per year",
  TransportBudget: "Transport budget",
  TruckType: "Truck type",
  SubTruckType: "Sub truck type",
  TruckCount: "Truck count",
  Lane: "Lane",
  LaneFromLocation: "Lane From Location",
  LaneToLocation: "Lane To Location",
  CreditLimit: "Credit limit",
  CreditPeriod: "Credit period",
  CreditApplication: "Credit application",
  CreditRisk: "Credit risk",
  GraceLimit: "Grace limit",
  GracePeriod: "Grace period",
  Threshold: "Threshold",
  Recepient: "Recepient",
  Channel: "Channel",
  Frequency: "Frequency",
  Call: "Call",
  OrderingEntityName: "Ordering entity Name",
  MapBillingEntity: "Map Billing entity",
  BillingEntityName: "Billing entity Name",
  MapOrderingEntity: "Map Ordering entity",
  VATImage: "VAT Image",
  VATRegistrationNumber: "VAT registration number",
  VATExpiryDate: "VAT Expiry date",
  TradeLicenseImage: "Trade License Image",
  TradeLicenseRegistrationNumber: "Trade License registration number",
  TradeLicenseExpiryDate: "Trade License Expiry date",
  CompanyRegImage: "Company Reg Image",
  CompanyRegNumber: "Company Reg number",
  CompanyRegExpiryDate: "Company Reg Expiry date",
  ServiceAgreementImage: "Service agreement Image",
  ServiceAgreementNumber: "Service agreement number",
  ServiceAgreementExpiryDate: "Service agreement Expiry date",
  InvoicingSubmissionType: "Invoicing Submission Type",
  TermsAndCondition: "Terms and Condition",
  InvoicingCycle: "Invoicing Cycle",
  InvoicingTerms: "Invoicing Terms",
  SampleApprovedInvoice: "Sample Approved Invoice",
  LineItem: "Line Item",
  SOALineItems: "SOA line items",
  Multicurrency: "Multicurrency",
  InvoicingSLA: "Invoicing SLA",
  AcknowledgementSLA: "Acknowledgement SLA",
  AmendmentSLA: "Amendment SLA",
  DisputeSLA: "Dispute SLA",
  RateType: "Rate Type",
  BilledBy: "Billed by",
  PODRequired: "POD required",
  StampOnPOD: "Stamp on POD",
  SignatureRequired: "Signature Required",
  PODType: "POD Type",
  PODSubmissionSLA: "POD Submission SLA",
  PODInstruction: "POD Instruction",

  Department: "Department",
  Name: "Name",
  FirstName: "First Name",
  MiddleName: "Middle Name",
  LastName: "Last Name",
  Designation: "Designation",
  PhoneNumber: "Phone number",
  Landline: "Landline",
  Purpose: "Purpose",
  Entities: "Entities",

  Access: "Access",
  PrimaryContact: "Primary contact",
  AuthorisedSignatory: "Authorised signatory",
  ServiceType: "Service type",
  SOP: "SOP",
  Mobile: "Mobile",
  SubCategory: "Sub-Category",
  UploadEvidence: "Upload Evidence",
  Station: "Station",
  POCName: "POC Name",
  POCDesignation: "POC Designation",
  POCEmployeeID: "POC Employee ID",
  POCEmail: "POC Email",
  POCMobile: "POC Mobile",
  Status: "Status",

  EmployeeID: "Employee ID",
  ContractName: "Contract Name",
  FromCity: "From City",
  ToCity: "To City",
  FromDate: "From Date",
  ToDate: "To Date",
  ComercialTruckType: "Truck Type",
  ComercialSubTruckType: "Sub Truck Type",
  ComercialWeight: "Weight (Tons)",

  Price: "Price",
  /*Supplier*/

  SupplierSupplierName: "Supplier Name",
  SupplierLanguagesKnown: "Languages Known",
  SupplierSupplyingEntityInformation: "Supplying entity information",
  SupplierSupplyingEntityName: "Supplying Entity Name",
  SupplierContactPersonName: "Contact Person Name",
  CommunicationPreference: "Communication Preference",
  SupplierPreferredCommunicationLang: "Preferred Communication Lang",
  PreferredCommunicationLanguage: "Preferred Communication Language",
  LanguagesKnown: "Languages Known",
  SupplyingEntityName: "Supplying Entity Name",
  ContactPersonName: "Contact Person Name",
  PrimaryMobileNumber: "Primary Mobile Number",
  Country: "Country",
  MapSupplyingEntity: "Map Supplying Entity",
  VATRegistrationNo: "VAT Registration No.",
  ExpiryDate: "Expiry Date",
  TradeLicenseNo: "TradeLicenseNo",
  DrivingLicenseNo: "Driving License No",
  PassportNo: "Passport No",

  IssuingCountry: "Issuing Country",
  NationalIDNo: "National ID No",
  VisaNo: "Visa No",
  CargoInsuranceNo: "Cargo Insurance No.",
  HaulierInsuranceNo: "Haulier Insurance No.",
  Amount: "Amount",
  SupplierName: "Supplier Name",
  Primarycontact: "Primary contact",
  BillingEntity: "Billing Entity",

  POSubmissionType: "PO Submission type",
  TermsAndAondition: "Terms and condition",
  POCycle: "PO Cycle",
  POTerms: "PO Terms",
  POReleaseDayDate: "PO Release Day/Date",
  POSample: "PO Sample",
  SelectLineitems: "Select Line items",
  InquiryServiceType: "Service type",
  LaneFromTo: "Lane (From-To)",
  Currency: "Currency",
  POGenerationSLA: "PO Generation SLA",
  POAcknowledgementSLA: "PO Acknowledgement SLA",
  POAmendmentSLA: "PO Amendment SLA",

  BilledTo: "Billed To",
  Address: "Address",
  WalletRequired: "Wallet Required",
  PaymentMethod: "Payment Method",
  WalletList: "Wallet List",
  BankList: "Bank List",
  BICORSWIFTCode: "BIC OR SWIFT Code",
  BankAccountNumber: "Bank Account Number",
  NatureofBusiness: "Nature of Business",
  ContractType: "Contract Type",
  ChargeType: "Charge Type",
  ContractPeriod: "Contract Period",

  RatePrice: "Rate (Price)",
  Mobile: "Mobile",
  SupplierUserType: "User Type",
  SupplierNatureOfBusiness: "Nature of Business",
  SupplierSupplierInformation: "Supplier Information",
  SupplierMobileNumber: "Mobile Number",
  SupplierAddressLine2: "Address Line 2",
  SupplierAddressLine3: "Address Line 3",
  SupplierStateOrProvince: "State OR Province",
  SupplierCity: "City",
  SupplierZipCode: "Zipcode",
  SupplierSEZipCode: "SE Zipcode",
  SupplierSEStateOrProvince: "SE State OR Province",
  SupplierSECity: "SE City",
  SupplierMapBillingEntity: "Map Billing Entity",
  SupplierBillingEntityName: "Billing Entity Name",
  SupplierContactPersonName: "Contact Person Name",
  SupplierCompanyName: "Company Name",
  SupplierDepartment: "Department",
  SupplierPOReleaseDayORDate: "PO Release Day OR Date",
  SupplierLineItems: "Line items",
  SupplierPaymentMethod: "Payment Method",
  SupplierStation: "Station ",
  SupplierPOCAddress: "POC Address",
  SupplierCategoryNameInPrefferedLanguage: "Category Name in Preferred Language",
  SupplierSubCategoryNameInPrefferedLanguage: "Sub-Category Name in Preferred Language",
  SupplierSupplierChoice: "Supplier Choice",
  SupplierNationalIDImage: "National ID Image",
  SupplierNationalIDExpiryDate: "National ID Expiry Date",
  SupplierDrivingLicenseImage: "Driving License Image",
  SupplierDLNumber: "DL Number",
  SupplierDLExpiryDate: "DL Expiry Date",
  SupplierPassportImage: "Passport Image",
  SupplierPassportNumber: "Passport Number",
  SupplierPassportExpiryDate: "Passport Expiry Date",
  SupplierPassportIssuingCountry: "Passport Issuing Country",
  SupplierVisaNumber: "Visa Number",
  SupplierVisaExpiryDate: "Visa Expiry Date",
  SupplierVisaIssuingCounrty: "Visa Issuing Country",
  SupplierCargoInsuranceImage: "Cargo Insurance Image",
  SupplierCargoInsuranceNumber: "Cargo Insurance Number",
  SupplierCargoInsuranceExpiryDate: "Cargo Insurance Expiry Date",
  SupplierHaulierInsuranceImage: "Haulier Insurance Image",
  SupplierHaulierInsuranceNumber: "Haulier Insurance Number",
  SupplierHaulierInsuranceExpiry: "Haulier Insurance Expiry",

  /*Truck*/
  RegistrationCertificationFront: "Registration certification front",
  RegistrationCertificationBack: "Registration certification back",
  RegistrationCertificationNumber: "Registration certification number",
  Units: "Units",
  PermitNumber: "Permit number",
  Owner: "Owner",
  SupplierMapping: "Supplier mapping",
  OnboardingFor: "Onboarding for",
  Weight: "Weight",
  TruckImage: "Truck image",
  PermitDocumentImage: "Permit document image",
  NumberPlateIssuerName: "Number Plate Issuer Name",
  RegistrationCountry: "Registration Country",
  RegistrationCertificateExpiryDate: "Expiry date",

  PermitExpiry: "Permit expiry",
  FitnessCertificateImage: "Fitness certificate image",
  FitnessCertificateNumber: "Fitness certificate number",
  FitnessCertificateExpiry: "Fitness certificate expiry",
  InsuranceImage: "Insurance image",
  InsuranceNumber: "Insurance number",
  InsuranceExpiry: "Insurance expiry",
  EmissionControlCertificateImage: "Emission control certificate image",
  EmissionControlCertificateNumber: "Emission control certificate number",
  EmissionControlCertificateExpiry: "Emission control certificate expiry",
  VehicleNumber: "Vehicle number",
  BrandName: "Brand name",
  Model: "Model",
  YearOfManufacture: "Year of manufacture",
  ChasisNumber: "Chasis number",
  DistanceCovered: "Distance covered",
  MotorNumber: "Motor number",
  TrailerType: "Trailer type",
  TrailerLength: "Trailer length",
  AxleCount: "Axle count",
  TrailerRegistrationImage: "Trailer registration Image",
  TrailerRegistrationNumber: "Trailer registration number",
  TrailerRegistrationExpiryDate: "Trailer registration Expiry date",
  ServiceLine: "Service line",
  PreferredCommodity: "Preferred commodity",
  GPSEquipped: "GPS equipped",
  GPSBrand: "GPS brand",
  GPSNumber: "GPS number",
  LastServiceDate: "Last service date",
  ServiceReport: "Service report",
  /*Driver*/
  FullName: "Full Name",
  EmailID: "Email ID",
  DateOfBirth: "Date of Birth",
  PreferredCommunicationLang: "Preferred Communication Lang",
  DrivingLicenseDetails: "Driving License details",

  DrivingLicenseExpiryDate: "Driving License Expiry Date",
  DrivingLicenseBaseCountry: "Driving License Base Country",
  DrivingLicenseNationality: "Driving License Nationality",
  DrivingLicenseIssuingCountry: "Driving License Issuing Country",
  DrivingLicenseIssueDate: "Driving License Issue Date",

  SingleTruckOwner: "Single Truck Owner",
  SearchSupplier: "Search Supplier",
  ProfilePicture: "Profile Picture",
  PasspostDetails: "Passpost details",
  VisaDetails: "Visa Details",
  PreferredLane: "Preferred Lane",
  DriverMobileNumber: "Mobile Number",
  DriverServiceType: "Service Type",
  DriverPreferredCommunicationLang: "Preferred Communication Lang",

  DrivingLicenseNumber: "Driving License No.",
  DrivingLicenseFront: "Driving License Front",
  DrivingLicenseBack: "Driving License Back",
  NationalID: "National ID",
  PasportNo: "Pasport No",
  VisaImage: "Visa Image",
  SourceLocation: "Source Location",
  DestinationLocation: "Destination Location",
  Front: "Front",
  Back: "Back",
  NationalIDNum: "National ID No.",

  //Inquiry
  SearchShipper: "Search Shipper",
  InquiryType: "Inquiry Type",
  Confirmed: "Confirmed",
  PriceDiscovery: "Price Discovery",
  CommodityType: "Commodity Type",
  WeightPerTruck: "Weight Per Truck",
  Unit: "Unit",
  OverWeight: "Over Weight",
  OddSize: "Odd Size",
  PickUpCity: "PickUp City",
  SourceAddress: "Source Address",
  PickUpContactName: "PickUp Contact Name",
  PickUpMobileNumber: "PickUp  Mobile Number",
  PreferredTime: "Preferred Time",
  SaveAddress: "Save Address",
  DropCity: "Drop City",
  DestinationAddress: "Destination Address",
  DropContactName: "Drop Contact Name",
  DropMobileNumber: "Drop Mobile Number",
  ConsigneeName: "Consignee Name",
  ConsigneeMobileNumber: "Consignee Mobile Number",
  ViewMap: "View Map",
  SubTruckTypeInquiry: "Sub-Truck Type",
  VATType: "VAT Type",
  VATInclusive: "VAT Inclusive",
  VATExclusive: "VAT Exclusive",
  OperationType: "Operation Type",
  CustomClearingAgent: "Custom Clearing Agent",
  CustomerRefNo: "Customer Ref No",
  ProjectNo: "Project No.",
  CountryCode: "Country Code",
  ConsigneeNumber: "Consignee Number",
  Remarks: "Remarks",
  UploadDocuments: "Upload Documents",
  RatePerTruck: "Rate Per Truck",
  InquiryID: "Inquiry ID",
  NumberOfTrucks: "No of Trucks",
  CreatedBy: "Created By",
  CreatedOn: "Created On",
  InquirySource: "Inquiry Source",
  SubType: "Sub Type",
  Rate: "Rate",
  LastUpdateBy: "Last Update By",
  LastUpdateOn: "Last Update On",
  CustomsClearance: "Customs Clearance",
  BillingAddress: "Billing Address",
  Date: "Date",
  TimeOfAction: "Time Of Action",
  ActionPerformed: "Action Performed",
  UserName: "UserName",
  Accept: "Accept",
  TotalTrucks: "Total Trucks",
  TrucksFullFilled: "Trucks FullFilled",
  TrucksUnfullfilled: "Trucks Unfullfilled",
  MoveDate: "Move Date",
  AreYouWantToSelectExistingFromRoutePlan: "Are you want to select existing from route plan",
  ContactName: "Contact Name",
  InquiryMobileNumber: "Mobile Number",
  PlanName: "Plan Name",
  Plan: "Plan",
  Selling: "Selling",
  Save: "Save",
  Cost: "Cost",
  Required: "Required",
  Sourced: "Sourced",
  NotSourced: "Not Sourced",
  PotentialSourcing: "Potential Sourcing",
  Count: "Count",
  Inquiry: "Inquiry",
  ViewDetails: "View Details",
  AuditTrail: "Audit Trail",
  SplitInquiry: "Split Inquiry",
  Reschedule: "Reschedule",
  CancelInquiry: "Cancel Inquiry",
  AcceptBehalfOnCustomer: "Accept Behalf on customer",
  SendToCustomer: "Send To Customer",
  ViewAllPlans: "View All Plans",
  LineItems: "Line Items",
  DeclareWinner: "Declare Winner",
  TruckAllocation: "Truck Allocation",
  ConfirmOrder: "Confirm Order",
  SLALineItems: "SLA Line Items",
  PickupDateAndTime: "Pickup Date and Time",
  EstimatedDuration: "Estimated Duration",
  FromLocation: "From Location",

  // Order
  ClientName: "Client Name",
  OrderPrice: "Order Price",
  OrderCost: "Order Cost",

  Assets: "Assets",
  Awarded: "Awarded",
  Submissions: "Submissions",
  submissions: "submissions",

  viewDetails: "View Details",
  CancelOrder: "Cancel Order",
  MoveType: "Move Type",
  MoveDateAndTime: "Move Date and Time",
  LoadingPOC: "Loading POC",
  Asset: "Asset",

  UnloadingPOC: "Unloading POC",

  ViewPlan: "View Plan",

  EditOrder: "Edit Order",
  ViewETAHistory: "View ETA History",
  UploadOrderDoc: "Upload Order Doc",

  OrderServiceType: "Service Type",
  Service: "Service",
  SourcingPOC: "Sourcing POC",
  ServiceCost: "Service Cost",
  ServiceDocs: "Service Docs",
  ViewCost: "View Cost",
  TripDoc: "Trip Doc",
  EditTrip: "Edit Trip",
  EditLineItem: "Edit Lineitem",
  DeleteLineItem: "Delete Lineitem",
  UploadLineItemDoc: "Upload Lineitem Doc",
  ViewCostFileUpload: "ViewCost File Upload",
  ViewCostDeleteFile: "ViewCost File Delete",
  ViewCostDeleteLineItem: "Line Item Delete",
  ViewCostAddLineItem: "Add Lineitem",
  OrderSubCategory: "Sub Category",
  Qty: "Qty",
  UnitPrice: "Unit Price",

  VATPercentage: "VAT Percentage",
  VATCharges: "VAT Charges",
  Total: "Total",
  UploadAction: "Upload Action",
  DeleteAction: "Delete Action",
  AddNewLineItemToRevenue: "Add Lineitem",
  Waybill: "Waybill",
  EditTripOk: "EditTrip Ok",
  CostFreightCharges: "Cost freight charges",
  RevenueFreightCharges: "Revenue freight charges",
  MoveDateToBackDate: "MoveDate to Back date",
  DeleteTrip: "Delete Trip",
  GPS: "GPS",
  DeleteVoucher: "Delete Voucher",
  OverrideInvoiceBlockedSettings: "Override Invoice BlockedSettings",
  OverrideOrderAfterLock: "Override Order After Lock",


  //user templates
  AddEditUser: "AddEdit User",
  DeactiveUser: "Deactive User",
  BulkUpdate: "Bulk Update",
  AssignAndRevokeTemplate: "Assign and Revoke Template",

  //Roles templates
  AddEditTemplate: "AddEdit Template",
  DeleteTemplate: "Delete Template",
  DeactiveTemplate: "Deactivate Template",
  AssignUser: "Assign User",

  //Lock template
  BlockOrder: "Block order",
  EditBlock: "Edit Block",
  UnblockOrder: "Unblock Order",
  AuditTrail: "Audit Trail"
};


export const DocTypes = {
  DL_FRONT: "DRLFD",
  DL_BACK: "DRLBD",
  NATIONAL_ID_FRONT: "NIDFD",
  NATIONAL_ID_BACK: "NIDBD",
  PASSPORT_FRONT: "PASSFD",
  PASSPORT_BACK: "PASSBD",
  VISA_FRONT: "VISAFD",
  VISA_BACK: "VISABD",
  TRUCK_FRONT: "TRECFD",
  TRUCK_BACK: "TRECBD",
  TRUCK_TRAILER_FRONT: "TRRCFD",
  TRUCK_TRAILER_BACK: "TRRCBD",
  TRADE_LICENSE_FRONT: "TRADELICFD",
  TRADE_LICENSE_BACK: "TRADELICBD",
  VAT_FRONT: "VATCERTFD",
  VAT_BACK: "VATCERTBD",
  COMPANY_FRONT: "COMPREGFD",
  COMPANY_BACK: "COMPREGBD",
  PROFILE_PIC: "PRFILPIC",
  ORDTRPINF: "ORDTRPINF",
  VINVDOC:'VINVDOC'
};

export const EntityTypes = {
  DRIVER: "Driver",
  TRUCK: "Truck",
  SUPPLIER: "Supplier",
  STO: "STO",
  Inquiry: "Inquiry",
  VendorInvoice:'VendorInvoice'
};

export const MoveTypes = {
  DOMESTIC: "Domestic",
  CROSS_BORDER: "Cross Border",
};

export const ThumbnailImagePath = {
  Pdf: "https://trukker.com/trukkerUAEapi/Images/pdf_file_icon.png",
  Doc: "https://trukker.com/trukkerUAEapi/Images/doc_file_icon.png",
  Excel: "https://trukker.com/trukkerUAEapi/Images/excel_file_icon.png"
}

export const BidType = {
  Awarded: "awarded",
  Submissions: "submissions",
  BookNow: "BookNow",
  ReviseBid: "ReviseBid"
}

export const MyBidHeading = {
  Awarded: "Awarded",
  Submissions: "Submissions"
}

export const BidStatus = {
  Booked: "Booked",
  Submitted: "Submitted",
  Expired: "Expired",
  Winner: "Winner",
  Rejected: "Rejected",
  FullyAssigned: "FullyAssigned",
  PartiallyAssigned: "PartiallyAssigned",
  Pending: "Pending",
  Awarded: "Awarded",
  Assignment: "Assignment",
  PartiallyBooked: "PartiallyBooked",
  Cancelled: "Cancelled",
  MarginApproval:"MarginApproval",
  DRTPending:'DRTPending',
  NotSelected:'NotSelected',
  OnHold:'OnHold',
  AwaitingWinnerAgain:'AwaitingWinnerAgain'
}

export const PreferredCurrency = [
  {

    label: <><span >₺ TRY</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>Turkish Lira</span> </>,
    key: "TRY",
    value: "TRY",
    currency: "TRY"
  },
  {
    label: <><span >$ USD</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>US Dollar</span> </>,
    key: "USD",
    value: "USD",
    currency: "USD"
  },
  {
    label: <><span >€ EUR</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>Eur</span> </>,
    key: "EUR",
    value: "EUR",
    currency: "EUR"
  },
  {

    label: <><span >£ GBP</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>Great British Pound</span> </>,
    key: "GBP",
    value: "GBP",
    currency: "GBP"
  },
]

export const PreferredCurrencyKazakh = [
  {
    label: <><span >₸ KZT</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>Kazakhstani Tenge</span> </>,
    key: "KZT",
    value: "KZT",
    currency: "KZT"
  },
  {
    label: <><span > ₽ RUB</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>Russian Ruble</span> </>,
    key: "RUB",
    value: "RUB",
    currency: "RUB"
  },
  {
    label: <><span >$ USD</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>US Dollar</span> </>,
    key: "USD",
    value: "USD",
    currency: "USD"
  },
  {
    label: <><span >€ EUR</span> - <span style={{ color: "rgba(0, 0, 0, 0.62)" }}>Eur</span> </>,
    key: "EUR",
    value: "EUR",
    currency: "EUR"
  },
]

export const InquiryStatus = {
  Pending: "Pending",
  Fulfilled: "Fulfilled",
  PartiallyFulfilled: "Partially Fulfilled"
}

export const HomeActionType = {
  LowerBidAvaiable: "LowerBidAvaiable",
  PendingAssignment: "PendingAssignment",
  CompleteAssignment: "CompleteAssignment",
  MoveTowardsOrder: "MoveTowardsOrder",
  MarkCompleted: "MarkCompleted",
  PODPending: "PODPending",
  MargingApprovalInProgress: "MargingApprovalInProgress",
  LoadingCompletionPending: "LoadingCompletionPending"
}

export const OrderDocStatus = {
  PENDING_DOC: "VerificationPending",
  // APPROVED_DOC: "Verified",
  APPROVED_DOC: ["Verified", "Approved"],
  REJECTED_DOC: "Rejected",
  PENDING_DOC_LINE_STATUS: "Pending",
}

export const TripStatus = {
  Upcoming: "upcoming", 
  Ready: "ready", //Turkey and Kazak
  StartForPickUp:"start for pick up",
  AtLoading:"at loading",
  LoadingCompleted:"loading completed",
  Completed:"completed"
}

export const SupplierStatus = {
  DETAILS_PENDING: "DetailsPending",
  DETAILS_SUBMITTED: "DetailsSubmitted",
  DETAILS_BANNED:"Banned",
  BLOCKED: "Blocked"
}

export const NotificationType = Object.freeze({
  DocumentsPending: "DocumentsPending",
  OnboardingVerified: "OnboardingVerified",
  VerificationInProgress: "VerificationInProgress",
  KYCDocumentsExpired: "KYCDocumentsExpired",
  KYCDocumentsRejected: "KYCDocumentsRejected",
  NewLoadMatchingPreferences: "NewLoadMatchingPreferences",
  BidWinnerDeclared: "BidWinnerDeclared",
  OrderConfirmed: "OrderConfirmed",
  BidDetailsChangedForTruckCount: "BidDetailsChangedForTruckCount",
  BidDetailsChangedForAssignments: "BidDetailsChangedForAssignments",
  LowestBidAvailable: "LowestBidAvailable",
  InquiryAllocated: "InquiryAllocated",
  MultipleTripStatusUpdationPending: "MultipleTripStatusUpdationPending",
  ReverseLoadFound: "ReverseLoadFound",
  InactiveInBidding: "InactiveInBidding",
  SavedLoadExpiration: "SavedLoadExpiration",
  ActionsPending: "ActionsPending",
  AssignmentIssue:"AssignmentIssue",
  OnUnblockSupplier:"OnUnblockSupplier",
  OnUpgradedToFleetOwnerC:"OnUpgradedToFleetOwnerC",
  AutoPriorWinnerReversed:"AutoPriorWinnerReversed",
  AutoWinnerReversed:'AutoWinnerReversed',
  BookmarkedClosingSoon:'BookmarkedClosingSoon',
  SubmittedClosingSoon:'SubmittedClosingSoon',
  AcceptanceActNow:"AcceptanceActNow",
  AssignmentActNow:"AssignmentActNow",
  Urgent:'Urgent',
  OnInvoiceApproved:'OnInvoiceApproved',
  OnInvoiceRejected:'OnInvoiceRejected',




});

export const OrderAlertType = {
    StatusUpdate: "StatusUpdate",
    LineItemDocumentUpload: "LineItemDocumentUpload",
    LineItemDocumentReupload: "LineItemDocumentReupload",
    ViewReverseLoads: "ViewReverseLoads",
    StatusDocumentReupload: "StatusDocumentReupload",
    ViewSimilarLoads: "ViewSimilarLoads",
    PODUpload: "PODUpload"
};

export const MenuNames ={
   HOME:"Home",
   LOADS:"Loads",
   ORDERS:"Orders",
   FLEET_MANAGEMENT:"Fleet Management",
   EARNINGS:"Earnings",
   ACCOUNT:"Account",
   FULFILLMENT:"Fulfillment",
   MY_BIDS:"My Bids",
   NOTIFICATIONS:"Notifications",
   SETTINGS:"Settings",
}

export const BidConfirmationTypes ={
     FINALIZING_CONFIRMATION:"FinalizingConfirmation",
     UPDATE_PRICE_NOW:"UpdatePriceNow",
     BAYAN_INQUIRY:"BayanInquiryWithLessTruckBid"
}

export const CURRENCY_RULES = {
  TRY: { maxDigits: 7, decimals: 2 },
  RUB: { maxDigits: 8, decimals: 2 },
  KZT: { maxDigits: 8, decimals: 2 },
  OMR: { maxDigits: 5, decimals: 3 },
  JOR: { maxDigits: 5, decimals: 3 },
  DEFAULT: { maxDigits: 5, decimals: 2 },
};

export const INVOICE_STATUS_TYPES={
  TRIPS_FOR_INVOICING:"TripsForInvoicing",
  POD_PENDING:"PODPending",
  INVOICE_IN_REVIEW:"InvoiceInReview"
}

export const RATE_TYPE ={
   SPOT:"Spot",
   CONTRACT:"Contract",
}